import {
  ADD_SUPPORT_FORUM,
  EDIT_SUPPORT_FORUM,
  GET_SUPPORTFORUM_LIST,
  SUPPORTFORUM_STATUS_UPDATE,
  SUPPORT_FORUM_DETAIL,
} from "../types";
import strings from "translate/language";
import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";
import supportForumSerive from "reduxStore/service/supportForumService";

export const getSupportForumList = (item) => async (dispatch) => {
  try {
    const res = await supportForumSerive.getSupportForumList(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_SUPPORTFORUM_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_SUPPORTFORUM_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const supportForumStatusUpdate = (item) => async (dispatch) => {
  try {
    const res = await supportForumSerive.supportFormStatusUpdate(item);
    if (res.data.status === 200) {
      dispatch({
        type: SUPPORTFORUM_STATUS_UPDATE,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
export const addSupportForum = (item) => async (dispatch) => {
  try {
    const res = await supportForumSerive.addSupportForum(item);
    if (res.data.status === 200) {
      dispatch({
        type: ADD_SUPPORT_FORUM,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
export const editSupportForum = (item) => async (dispatch) => {
  try {
    const res = await supportForumSerive.editSupportForum(item);
    if (res.data.status === 200) {
      dispatch({
        type: EDIT_SUPPORT_FORUM,
        payload: res.data,
      });
      successToast(res.data.message);
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};
export const getsupportForumDetail = (item) => async (dispatch) => {
  try {
    const res = await supportForumSerive.supportForumDetail(item);

    if (res.data.status === 200) {
      dispatch({
        type: SUPPORT_FORUM_DETAIL,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
